/* eslint-disable @typescript-eslint/no-var-requires */
import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import ReactResizeDetector from 'react-resize-detector';

import ImgPoint from '../../../../../assets/animation_point.gif';
import ImgArrowLeft from '../../../../../assets/arrow-left-long.png';
import ImgArrowRight from '../../../../../assets/arrow-right-long.png';
import { useStore } from '../../../store';

interface IComponent001Item {
  title: string;
  text: string;
  img: string;
  number?: number;
}
interface IComponent001Props {
  title1: string;
  title2: string;
  description: string;
  items: IComponent001Item[];
}

const Component001: React.FunctionComponent<IComponent001Props> = ({
  title1,
  title2,
  description,
  items,
}) => {
  const { language } = useStore();

  const [currentSlide, setCurrentSlide] = useState(0);
  const [slideClicked, setSlideClicked] = useState(items.map(() => false));
  const [containerWidth, setContainerWidth] = useState(1440);
  const [padding, setPadding] = useState(7);
  const [maxImageheight, setMaxImageHeight] = useState(0);
  const [itms, setItms] = useState<IComponent001Item[]>([]);

  useEffect(() => {
    setItms(
      items.map((itm: IComponent001Item, idx: number) => ({
        ...itm,
        number: idx + 1,
      }))
    );
  }, [items]);

  const nextSlide = () => {
    if (currentSlide >= itms.length) {
      return;
    }
    const _nextSlide = currentSlide + 1;
    slideClicked[_nextSlide] = true;
    setCurrentSlide(_nextSlide);
    setSlideClicked(slideClicked);
  };
  const prevSlide = () => {
    if (currentSlide === 0) {
      return;
    }
    const _prevSlide = currentSlide - 1;
    slideClicked[_prevSlide] = true;
    setCurrentSlide(_prevSlide);
    setSlideClicked(slideClicked);
  };
  const onResize = (w: any) => {
    setContainerWidth(w);
    if (w <= 1074) {
      setPadding(2);
    }
  };
  const onImageResize = (w: any, h: any) => {
    setMaxImageHeight((oh) => (oh >= h ? oh : h));
    console.log(h);
  };
  return (
    <div className="phishing-indentify-section" style={{ height: 'auto' }}>
      <div className="title">
        <div className="l1" dangerouslySetInnerHTML={{ __html: title1 }} />
        <div className="l2" dangerouslySetInnerHTML={{ __html: title2 }} />
      </div>
      <p
        className="phishing-indentify-desc"
        dangerouslySetInnerHTML={{ __html: description }}
      />
      <div className="phishing-indentify-tabs">
        {itms
          .filter(
            (item: IComponent001Item, idx: number) =>
              (currentSlide < 3 && idx < 3) || (currentSlide >= 3 && idx >= 3)
          )
          .map((itm: IComponent001Item, idx: number) => (
            <div
              key={idx}
              className={`phishing-indentify-tab ${
                currentSlide % 3 === idx ? 'active' : ''
              }`}
              onClick={() => setCurrentSlide(idx)}
              style={{ height: 'auto' }}
            >
              <div className="number">
                {itm.number || 0 < 10 ? `0${itm.number || 0 + 1}` : itm.number}
              </div>
              <div
                className="text"
                dangerouslySetInnerHTML={{ __html: itm.title }}
              />
            </div>
          ))}

        <div className="phishing-indentify-switch-btns">
          <img className="click-point" src={ImgPoint} alt="" />
          <Button
            className="prev-button"
            type="text"
            disabled={currentSlide === 0}
            onClick={() => prevSlide()}
          >
            <img src={ImgArrowLeft} alt="" />
          </Button>
          <Button
            className="next-button"
            type="text"
            disabled={currentSlide === itms.length - 1}
            onClick={() => nextSlide()}
          >
            <img src={ImgArrowRight} alt="" />
          </Button>
        </div>
      </div>
      <ReactResizeDetector onResize={onResize}>
        <div
          className="phishing-indentify-container"
          style={{
            height:
              maxImageheight <= 369 || maxImageheight >= 450
                ? `calc(${maxImageheight}px + 22vw)`
                : `calc(${maxImageheight}px + 5vw)`,
          }}
        >
          <div
            className="phishing-indentify-body"
            style={{
              left: `calc(${currentSlide * padding}rem - ${
                currentSlide * containerWidth
              }px)`,
            }}
          >
            {itms.map((itm: IComponent001Item, idx: number) => (
              <div
                key={idx}
                className="phishing-indentify-item"
                style={{
                  width: `calc(${containerWidth}px - ${padding}rem)`,
                }}
              >
                <ReactResizeDetector onResize={onImageResize}>
                  <div>
                    <img
                      width="740px"
                      key={language}
                      src={require(`../../../../../assets/${itm.img}`).default}
                      alt=""
                    />
                  </div>
                </ReactResizeDetector>
                <div
                  className="phishing-indentify-text"
                  dangerouslySetInnerHTML={{ __html: itm.text }}
                />
              </div>
            ))}
          </div>
        </div>
      </ReactResizeDetector>
    </div>
  );
};

export default Component001;
